export default __webpack_public_path__ + "assets/lustosa-component.ca06f4f0.svg";